/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionssubtitle2Inputs */

const en_openquestionssubtitle2 = /** @type {(inputs: Openquestionssubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Things a lawyer would probably ask you. Add a quick answer here, ask the assistant, or skip if it doesn't matter to you.`)
};

const pt_openquestionssubtitle2 = /** @type {(inputs: Openquestionssubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coisas que um advogado provavelmente lhe perguntará. Adicione uma resposta rápida aqui, peça ajuda ao assistente, ou ignore se não for relevante.`)
};

/**
* | output |
* | --- |
* | "Things a lawyer would probably ask you. Add a quick answer here, ask the assistant, or skip if it doesn't matter to you." |
*
* @param {Openquestionssubtitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionssubtitle2 = /** @type {((inputs?: Openquestionssubtitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionssubtitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionssubtitle2(inputs)
	return pt_openquestionssubtitle2(inputs)
});
export { openquestionssubtitle2 as "openQuestionsSubtitle" }